import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import LogoWrapper from "../LogoWrapper/LogoWrapper";
import TextInput from "../TextInput/TextInput";
import BackButton from "../BackButton/BackButton";
import { validateEmail } from "../utils/common";
import { useFont } from "../../contexts/FontContext/FontContext";
import axios from "axios";
import styles from "./ForgotPassword.module.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [linkSent, setLinkSent] = useState(false); // State to track if the link was sent
    const [error, setError] = useState("");
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 
    const location = useLocation();
    const navigate = useNavigate();
    const fromSettings = location.state?.fromSettings || false;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateEmail(email)) {
            setError("Invalid email format.");  // Use validateEmail to check format
        } else {
            try {
                // Send a POST request to the backend to trigger the password reset email
                const apiUrl = process.env.REACT_APP_API_URL;  // Ensure you have this set in your environment variables
                const response = await axios.post(`${apiUrl}/api/password_reset/`, { email });
                // If the request is successful
                setLinkSent(true);
            } catch (error) {
                // Handle errors, like invalid email or server errors
                if (error.response && error.response.data) { setError(error.response.data.error || "An error occurred. Please try again."); }   
                else { setError("An error occurred. Please try again."); }
            }
        }
    };

    return (
        <div className={`${styles.forgot_password_container} ${fontFamilyOne}`}>
            <Helmet>
                <title>Forgot Password</title>
            </Helmet>
            <LogoWrapper class_={styles.forgot_password_logo} src={`${process.env.PUBLIC_URL}/images/partial_logo.png`} />
            {!linkSent ? (
                <>
                	{error && <p className="error_message">{error}</p>}
                    <p className={`titles ${styles.email_reset_instruction}`}>Enter email to send password reset link.</p>
                    <form className={styles.forgot_password_email_form} onSubmit={handleSubmit}>
                        <TextInput inputType={"new_email"} value={email} onChange={(e) => setEmail(e.target.value)} required />  
                        <button className={`login_buttons ${styles.submit_forgot_password_link} ${fontFamilyOne}`} type="submit">Send link</button>
                    </form>
                    <BackButton button_id={styles.forgot_password_back_button} image_id={styles.forgot_password_back_button_arrow} customBack={fromSettings ? () => navigate("/home", { state: { page: "Settings" } }) : null} />
                </>
            ) : (
                <p className={`titles ${styles.email_sent_confirmation}`}>Check your email for password reset link.</p>
            )}
        </div>
    );
};

export default ForgotPassword;
